module.exports = __webpack_public_path__ + "img/q.7af30c81.png";